import React from 'react';
import { useSEOMetaTags } from '../../hooks/useSEOMetaTags';

interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string[];
  locale: string;
  path?: string;
  ogImage?: string;
  type?: 'website' | 'article';
  propertyData?: any;
  breadcrumbs?: { name: string; url: string }[];
  faqData?: Array<{question: string, answer: string}>;
  reviewData?: {
    reviewBody: string;
    reviewerName: string;
    ratingValue: number;
    datePublished: string;
  };
}

const SEOHead: React.FC<SEOHeadProps> = ({
  title,
  description,
  keywords = [],
  locale,
  path = '',
  ogImage = '/og-image.jpg',
  type = 'website',
  propertyData,
  breadcrumbs,
  faqData,
  reviewData
}) => {
  useSEOMetaTags({
    title,
    description,
    keywords,
    locale,
    path,
    ogImage,
    type,
    propertyData,
    breadcrumbs,
    faqData,
    reviewData
  });

  return null; // This component doesn't render anything to the DOM
};

export default SEOHead;
